import { useCallback } from 'react';
import get from 'lodash/get';
import { useWidgetContext } from '@/provider';

type Props = { fallback?: string; args?: Record<string, unknown> };
const replaceVars = (input: string, args: Record<string, unknown>) =>
  Object.entries(args).reduce((carry, [key, val]) => {
    carry = carry.replace(`{${key}}`, String(val));
    return carry;
  }, input);

export function useTranslation() {
  const { i18n } = useWidgetContext();

  const t = useCallback(
    (key: string, fallbackOrProps: string | Props = '') => {
      const data = i18n?.data || {};
      const props =
        typeof fallbackOrProps === 'string'
          ? { fallback: fallbackOrProps }
          : fallbackOrProps;
      const translated = get(data, key, props.fallback) as string;
      return props.args && translated
        ? replaceVars(translated, props.args)
        : translated;
    },
    [i18n]
  );

  return { t, locale: i18n };
}
